import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  freightSectionLabel: {
    description: 'UoM modal Freight Information section label',
    defaultMessage: 'Freight Information',
    id: 'nwD1D7',
  },
  freightClassLabel: {
    description: 'UoM modal Freight Class input label',
    defaultMessage: 'Freight Class',
    id: 'X34kzl',
  },
  nmfcCodeLabel: {
    description: 'UoM modal NMFC Code input label',
    defaultMessage: 'NMFC Code',
    id: '2m3sLk',
  },
  nmfcCodeHelper: {
    description: 'UoM modal NMFC Code input helper text',
    defaultMessage: 'National Motor Freight code (e.g. 060000 or 060000-01). Optional.',
    id: 'WRsuMm',
  },
});
